import * as React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Grid, TextField } from '@mui/material';
import { Button, ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value: string;
  size?: textsize;
  box?: boolean;
  color?: any;
  readOnly?: boolean;
  clearValue?: boolean;
  disablePast?: boolean;
  disableTime?: boolean;
  disableDay?: any;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value: any) => void;
  error?: string;
}

export const InputDate: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = React.useState<boolean>();
  const [value, setValue] = React.useState<any>(null);
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }

  const onClickClear = () => {
    if (isMobile) setOpen(false);
    setValue(null);
    props.onChange?.(props.name, null);
  }

  React.useEffect(() => {
    setValue(props.value);
    
  },[props.value])

  return (
    <Grid id={props.id || props.name}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        
        <DateTimePicker
          value={value}
          inputFormat={'DD-MMM-YYYY' + (props.disableTime? '' : ' HH:mm')}
          ampm={false}
          closeOnSelect={true}
          disableMaskedInput
          disableOpenPicker = {props.readOnly}
          disablePast = {props.disablePast}
          shouldDisableDate={(date) => {return props.disableDay?.includes(date?.$W)}}     
          hideTabs={!!props.disableTime}
          open={isMobile? (open? true:false) : undefined}
          readOnly={props.readOnly}
          showToolbar={false}
          views={props.disableTime? ['year', 'month','day'] : ['year', 'month','day','hours','minutes']}
          componentsProps={{
            actionBar: {actions: ['accept','cancel']},
          }}
          onChange={(newValue) => {
            setValue(newValue || null);
            props.onChange?.(props.name, newValue || null);
          }}
          onClose={() => setOpen(false)}
          InputProps={{
            startAdornment: !props.readOnly &&
              <>
              {props.value && props.clearValue &&
                <Button startIcon='clear' size='extrasmall' disablePadding sx={{order: 1}} onClick={onClickClear} />
              }
              {isMobile &&
                <Button startIcon='event' size='medium' disablePadding sx={{order: 1}} onClick={() => setOpen(true)} />
              }
              </>
          }}
          InputAdornmentProps={{
            position: 'end',
            sx: {order: 2, marginLeft: 0.2, marginRight: 1.4,
              '.MuiIconButton-root': { padding: 0 },
              '.MuiSvgIcon-root': {margin: 0, color: 'primary.main', fontSize: ThemeTextSize('small').iconSize },
            }
          }}
          PopperProps={{
            sx: {
              '.MuiPaper-root': { padding: 5 },
              '.MuiPickersDay-dayWithMargin': { }
            },
          }}
          renderInput={(params) => 
            <TextField  {...params}  
              name={props.name}
              label={props.label}
              placeholder={props.placeHolder} 
              inputProps={{ ...params.inputProps, readOnly: true }}
              InputProps={{ ...params.InputProps,
                sx: {fontSize: fontSize(), bgcolor: props.color, borderRadius: 3, marginTop: props.box? 1.5 : 0}
              }}
              InputLabelProps={{
                shrink: true,
                sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
              }}
              FormHelperTextProps={{
                sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
              }}
              sx = {{'& legend': {width: props.box? 0 : undefined}}}
              margin={props.disableMargin? 'none' : 'normal'}
              variant={props.box? undefined : 'standard'}
              fullWidth
              helperText={props.error}
              error= {props.error? true: false}
            /> 
          }
        />
        
      </LocalizationProvider>
    </Grid>
  )
}